import { useAppSelector } from "src/redux/hooks";

/**
 * What this tenant calls a "warehouse" — configurable per tenant (Settings
 * > Organization) since some call it a store, a location, a branch. This is
 * a UI label only: the Warehouse model, warehouseId fields, and routes all
 * keep their real names regardless of what's returned here.
 */
const useWarehouseLabel = () => {
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  const singular = user?.tenantDetails?.warehouseLabel?.singular?.trim() || "Warehouse";
  const plural = user?.tenantDetails?.warehouseLabel?.plural?.trim() || "Warehouses";

  return { singular, plural };
};

export default useWarehouseLabel;
